import { styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { LocalInsert } from '@weblite/persist'
import { PrimaryButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'
import { StartUpModalQueue } from '$func/startup-modal-handler'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { BALE_PROMO_LOCAL_KEY } from '$logic/client-device'

const BALE_CHANNEL_URL = 'https://ble.ir/alphaschoolir'

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  margin-top: auto;
  gap: 12px;
`

const LogoContainer = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 40px 16px;
  border-radius: 18px;
  background:
    linear-gradient(
      135deg,
      rgba(25, 174, 168, 0.18),
      rgba(29, 178, 216, 0.16)
    ),
    #e8fbfa;
`

const persistDismiss = () => {
  LocalInsert(BALE_PROMO_LOCAL_KEY, {
    shown: true,
    time: dateWithOffset(),
  })
}

export function BaleChannelPromotionDialog({ isOpen }: { isOpen: boolean }) {
  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={() => {
        persistDismiss()
        StartUpModalQueue.openNextModal()
        closeCurrentModal()
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '32px 16px',
          gap: '32px',
          alignItems: 'center',
        }}
      >
        <LogoContainer>
          <img
            src="assets/images/bale.png"
            width="72px"
            height="72px"
            alt=""
          />
        </LogoContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          <Typography variant="h2">
            {t('baleChannelPromotion.title')}
          </Typography>

          <Typography variant="paragraph1" textAlign="center">
            {t('baleChannelPromotion.description')}
          </Typography>
        </div>
      </div>

      <ButtonContainer>
        <PrimaryButton
          fullWidth
          text={t('baleChannelPromotion.join')}
          onClick={() => {
            window.open(BALE_CHANNEL_URL, '_blank', 'noopener,noreferrer')
            persistDismiss()
            StartUpModalQueue.openNextModal()
            closeCurrentModal()
          }}
        />
      </ButtonContainer>
    </BottomDrawer>
  )
}
